export enum EditFormMode {
    Create = "Create",
    Update = "Update"
}